module.exports = __webpack_public_path__ + "static/logo-bmw-05a9419ab4b7a5beaa3246a785b5919f.png";